module.exports = __webpack_public_path__ + "img/2.006d7e09.jpg";